import { HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { TreeModule } from 'angular-tree-component';
import { DndModule } from 'ng2-dnd';
import { ModalModule } from 'ngx-bootstrap/modal';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ColorPickerModule } from 'ngx-color-picker';
import { SubscribeService } from 'shared/services';
import { SharedModule } from 'shared/shared.module';
import {
  AppComponent,
  CrowdsourceComponent,
  EditProjectComponent,
  FilterSubjectPipe,
  LayersAutocompleteComponent,
  LayersComponent,
  LayerSettingsComponent,
  PermissionsComponent,
  ProjectComponent,
  ProjectFormComponent,
  SearchComponent,
  ToolsComponent
} from './components';
import { AppService, LayerService, PermissionService, ProjectService, ServicesService } from './services';

@NgModule({
  imports: [
    BrowserModule,
    HttpClientModule,
    HttpClientXsrfModule.withOptions({
      cookieName: 'csrftoken',
      headerName: 'X-CSRFToken'
    }),
    FormsModule,
    TreeModule.forRoot(),
    SharedModule,
    DndModule.forRoot(),
    ColorPickerModule,
    InfiniteScrollModule,
    ModalModule.forRoot()
  ],
  declarations: [
    AppComponent,
    ProjectComponent,
    ProjectFormComponent,
    EditProjectComponent,
    LayersComponent,
    LayersAutocompleteComponent,
    PermissionsComponent,
    CrowdsourceComponent,
    LayerSettingsComponent,
    FilterSubjectPipe,
    SearchComponent,
    ToolsComponent
  ],
  bootstrap: [AppComponent],
  providers: [ProjectService, PermissionService, LayerService, ServicesService, SubscribeService, AppService]
})
export class AppModule {}
